<template>
    <v-data-table
        :headers="realHeaders"
        :items="list"
        class="elevation-1"
        :items-per-page="-1"
        hide-default-footer
        disable-sort
    >
        <template #item="row">
            <tr>
                <td v-for="(header, i) in realHeaders" :key="i">
                    <template v-if="header.text === 'Устройства'">
                        <router-link v-if="row.item.deviceId" :to="`/devices/view/${row.item.deviceId}`">
                            {{ getCellValue(row.item, header) }}
                        </router-link>

                        <EventExtraDeviceEmissions :value="row.item" />
                    </template>
                    <template v-else>
                        {{ getCellValue(row.item, header) }}
                    </template>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import Browser, {Header} from '@/mixins/Browser'
import {Event} from '@/models/Event'
import {displayTime} from '@/utils/datetime'
import EventExtraDeviceEmissions from '@/components/common/EventExtraDeviceEmissions.vue'

@Component({
    components: {EventExtraDeviceEmissions},
})
export default class PacketBrowser extends Browser<Event>
{
    defaultHeaders: Header<Event>[] = [
        {text: 'ID', value: 'id', align: 'start'},
        {text: 'Уровень', value: 'levelLabel'},
        {text: 'Тип', value: 'typeLabel'},
        {text: 'Устройства', value: e => e.device?.name ?? ''},
        {text: 'Актуально', value: e => e.isActual ? 'да' : 'нет'},
        {text: 'Произошло в', value: e => displayTime(e.occurredAt)},
    ]

    async fetchList() {
        this.list = await this.api.listEvents({
            ...this.filters,
            expand: ['levelLabel', 'typeLabel', 'device.name', 'extra'],
        })
    }
}
</script>
